<template>
  <div class="assigns">
    <assignsList ref="list"></assignsList>
    <router-view @list-reload="listReload" />
  </div>
</template>

<script>
import assignsList from './assignsList.vue'

export default {
  components: {
    assignsList
  },
  methods: {
    async listReload() {
      await this.$refs.list.reload()
    }
  }
}
</script>
<style scoped>
.assigns {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/assigns/assigns.vue